import React, { useState, useEffect } from 'react'
import ReactECharts from 'echarts-for-react'
import { Col, Row } from 'rsuite'
import { numberThousandSeparator } from '../../../utils/formatterUtil'

export default function OverallNodeChart({
  compStyle = { height: '400px', width: '100%' },
  nodeData = [],
  nodeGroup = [],
  budgetData = [],
  onClickCheart = () => {},
  ...props
}) {
  const [chartOption, setChartOption] = useState()

  const optionChart = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999',
        },
      },
    },
    legend: {
      data: ['จำนวนโครงการ', 'งบประมาณ'],
    },
    xAxis: [
      {
        type: 'category',
        data: nodeGroup,
        axisPointer: {
          type: 'shadow',
        },
      },
    ],
    yAxis: [
      {
        type: 'value',
        name: 'จำนวนโครงการ',
        // min: 0,
        // max: 500,
        interval: 500,
      },
      {
        type: 'value',
        name: 'งบประมาณ',
        // min: 0,
        // max: 500,
        interval: 10000000,
        axisLabel: {
          formatter: '฿{value} M',
        },
      },
    ],
    series: [
      {
        name: 'จำนวนโครงการ',
        type: 'bar',
        itemStyle: {
          color: '#2da888', // สีเดียวทั้งหมด
        },
        tooltip: {
          valueFormatter: function (value) {
            return value
          },
        },
        data: nodeData,
      },
      {
        name: 'งบประมาณ',
        type: 'line',
        yAxisIndex: 1,
        itemStyle: {
          color: '#f17e23', // สีเดียวทั้งหมด
        },
        tooltip: {
          valueFormatter: function (value) {
            return value + ' M'
          },
        },
        data: budgetData,
      },
    ],
  }

  useEffect(() => {
    setChartOption(optionChart)
  }, [])

  const onEvents = {
    click: (params) => {
      // console.log('คลิกที่:', params)

      onClickCheart(params.data)
    },
    // mouseover: (params) => {
    //   console.log('Hover:', params.name)
    // },
  }

  if (!chartOption) {
    return false
  }

  return (
    <div>
      <ReactECharts
        option={chartOption}
        style={compStyle}
        className={'react_for_echarts'}
        onEvents={onEvents}
      />
    </div>
  )
}
